module.exports = __webpack_public_path__ + "img/4.638db045.png";